// L'agente di stampa (printers-mananger/src/constants/paymentErrors.js) scrive sull'ordine SOLO codici
// (payment_error_code, payment_error_message come dettaglio tecnico, bill_number con bill == 2).
// Qui i codici vengono tradotti in testo con spiegazione e in "cosa fare" per l'operatore.
const PAYMENT_ERROR_TEXTS = {
	EPTR_REC_EMPTY: "Carta scontrino finita",
	EPTR_COVER_OPEN: "Coperchio della stampante fiscale aperto",
	EFT_POS_ERROR: "Pagamento rifiutato o annullato sul terminale POS",
	VIVA_DECLINED: "Pagamento rifiutato o annullato sul terminale Viva Wallet",
	FP_NO_ANSWER: "La stampante fiscale non risponde",
	PRINTER_ERROR: "Errore della stampante fiscale",
	PRINTER_ERROR_3: "Stampante fiscale offline: carta finita o coperchio aperto",
	PRINTER_ERROR_11: "Operazione non valida dopo uno storno o un modificatore",
	PRINTER_ERROR_16: "Importo zero o attributo di vendita non valido",
	PRINTER_ERROR_17: "Sconto o maggiorazione su subtotale zero o negativo",
	PRINTER_ERROR_21: "Sconto o maggiorazione sul subtotale non consentiti dai reparti usati",
	PRINTER_UNREACHABLE: "Stampante fiscale non raggiungibile in rete",
	PRINTER_TIMEOUT: "Timeout: la stampante non ha risposto nei tempi previsti",
	PRINTER_NO_RESPONSE: "Connessione interrotta (socket hang up): la stampante ha chiuso la comunicazione",
	PRINTER_NOT_CONFIGURED: "Nessuna stampante fiscale attiva per questo ordine",
	PRINTER_NOT_READY: "Stampante fiscale non ancora disponibile sull'agente",
	BILL_ERROR: "Pagamento autorizzato ma scontrino fiscale non emesso",
	PAX_ERROR: "Esito del pagamento PAX incerto: la carta potrebbe essere stata addebitata",
	PAX_REBILL_BLOCKED: "Scontrino non inviato al PAX: avrebbe addebitato di nuovo la carta. Emetterlo su una stampante fiscale senza PAX",
	P17_ERROR: "Errore di comunicazione con il terminale POS",
	AGENT_EXCEPTION: "Errore interno del server di stampa",
	DOJO_DECLINED: "Pagamento rifiutato dalla carta",
	DOJO_CANCELED: "Pagamento annullato",
	DOJO_EXPIRED: "Esito del pagamento non confermato",
	DOJO_EXPIRED_MANUAL: "Esito del pagamento non confermato: registrato manualmente dall'operatore",
	DOJO_SIGNATURE_REJECTED: "Firma rifiutata",
	DOJO_TERMINAL_NOT_FOUND: "Terminale Dojo non trovato o spento",
	DOJO_TERMINAL_BUSY: "Terminale Dojo occupato o in un menu",
	DOJO_CONFIG: "Configurazione Dojo del negozio non valida",
	DOJO_AUTH: "API key Dojo non valida",
	DOJO_UNREACHABLE: "Dojo non raggiungibile",
	DOJO_NO_TERMINAL: "Nessun terminale Dojo configurato (Impostazioni > Dojo)",
	DOJO_ORDER_NOT_PAYABLE: "L'ordine non è in attesa di pagamento con Dojo",
	UNKNOWN: "Errore non classificato",
};

const PAYMENT_ERROR_HINTS = {
	EPTR_REC_EMPTY: "Sostituire il rotolo di carta nella stampante fiscale, poi premere Riprova.",
	EPTR_COVER_OPEN: "Chiudere il coperchio della stampante fiscale, poi premere Riprova.",
	EFT_POS_ERROR: "Il cliente può riprovare con la carta oppure scegliere un altro metodo di pagamento.",
	VIVA_DECLINED: "Il cliente può riprovare con la carta oppure scegliere un altro metodo di pagamento.",
	PRINTER_UNREACHABLE: "Controllare che la stampante fiscale sia accesa e collegata alla rete (cavo o Wi-Fi).",
	PRINTER_TIMEOUT: "Controllare che la stampante fiscale sia accesa e collegata, poi premere Riprova.",
	PRINTER_NO_RESPONSE: "Spegnere e riaccendere la stampante fiscale, poi premere Riprova.",
	PRINTER_NOT_CONFIGURED: "Verificare nel backoffice che esista una stampante fiscale attiva.",
	PRINTER_NOT_READY: "L'agente sta caricando la stampante: riprovare tra qualche secondo.",
	PRINTER_ERROR: "Controllare il display della stampante fiscale, poi premere Riprova.",
	FP_NO_ANSWER: "Controllare che la stampante fiscale sia accesa e collegata, poi premere Riprova.",
	BILL_ERROR:
		"Il pagamento potrebbe essere stato addebitato ma lo scontrino non è stato emesso. NON riprovare prima di aver verificato l'estratto del terminale POS.",
	PAX_ERROR:
		"NON riprovare: controllare lo scontrino/estratto del PAX. Se l'addebito c'è usare \"Conferma pagato\" in Vendite, altrimenti \"Annulla ordine\".",
	P17_ERROR: "Verificare che il terminale POS sia acceso e collegato, poi premere Riprova.",
	AGENT_EXCEPTION: "Premere Riprova; se il problema persiste contattare l'assistenza.",
	DOJO_DECLINED: "Il cliente può riprovare con la carta oppure scegliere un altro metodo di pagamento.",
	DOJO_CANCELED: "Il pagamento è stato annullato sul terminale: premere Riprova per ripeterlo.",
	DOJO_EXPIRED:
		"Controllare lo schermo o lo scontrino del terminale Dojo: se il pagamento risulta riuscito registrarlo come pagato, altrimenti premere Riprova.",
	DOJO_EXPIRED_MANUAL: "Verificare l'esito sullo scontrino del terminale Dojo.",
	DOJO_SIGNATURE_REJECTED: "La firma non corrisponde: il cliente può pagare con un'altra carta o un altro metodo.",
	DOJO_TERMINAL_NOT_FOUND: "Controllare che il terminale Dojo sia acceso e connesso, poi premere Riprova.",
	DOJO_TERMINAL_BUSY: "Chiudere eventuali menu o transazioni aperte sul terminale Dojo, poi premere Riprova.",
	DOJO_CONFIG: "Verificare nel backoffice la configurazione del metodo di pagamento Dojo del negozio.",
	DOJO_AUTH: "Verificare nel backoffice l'API key Dojo del negozio.",
	DOJO_UNREACHABLE: "Controllare la connessione a internet, poi premere Riprova.",
	DOJO_NO_TERMINAL: "Selezionare il terminale Dojo in Impostazioni > Dojo, poi premere Riprova.",
	DOJO_ORDER_NOT_PAYABLE: "Ricaricare l'ordine e verificare che il pagamento sia impostato su Dojo.",
	UNKNOWN: "Premere Riprova; se il problema persiste contattare l'assistenza.",
};

export function paymentErrorHint(code) {
	return PAYMENT_ERROR_HINTS[code] || null;
}

// Registratore PAX (PAX_ERROR_<n>): i numeri di errore non sono quelli Epson e il PAX puo' emettere lo
// scontrino anche dopo aver risposto errore (YELLGO-6263).
function knownErrorText(code) {
	if (PAYMENT_ERROR_TEXTS[code]) return PAYMENT_ERROR_TEXTS[code];
	const pax = code.match(/^PAX_ERROR_(\d+)$/);
	if (pax) {
		return `Il registratore PAX ha rifiutato lo scontrino (errore ${pax[1]}): potrebbe averlo emesso comunque, verificare sul registratore prima di ristamparlo`;
	}
	return null;
}

// Spiegazione di un codice; codice sconosciuto -> il codice grezzo.
export function paymentErrorText(code) {
	const key = String(code || "").trim();
	return knownErrorText(key) || key;
}

// Errore di pagamento (payment_error_code + dettaglio tecnico): "Spiegazione (dettaglio)".
export function paymentErrorSummary(order) {
	if (!order || !order.payment_error_code) return "";
	const text = paymentErrorText(order.payment_error_code);
	// per BILL_ERROR il dettaglio e' il codice dello scontrino: viene tradotto a sua volta
	if ((order.payment_error_code === "BILL_ERROR" || order.payment_error_code === "PAX_ERROR") && order.payment_error_message) {
		return `${text} - code: ${order.payment_error_message} - ${paymentErrorText(order.payment_error_message)}`;
	}
	return order.payment_error_message ? `${text} (${order.payment_error_message})` : text;
}

// Errore scontrino (bill == 2): bill_number contiene il solo codice scritto dall'agente.
export function billErrorText(billNumber) {
	const code = String(billNumber || "").trim();
	if (!code) return "";
	const text = knownErrorText(code);
	return text ? `Errore scontrino - code: ${code} - ${text}` : `Errore scontrino - code: ${code}`;
}
